

















import Vue from "vue";

// Vue Components
import DeviceTreeAppPage from "@/components/DeviceTreeAppPage.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";

export default Vue.extend({
    components: {
        DeviceTreeAppPage,
    },
    data() {
        return {
            dataTableItemsPerPage,
            deviceTreeSelectedObjectItems: [],
            currentPaginationOptions: {
                page: 1,
                itemsPerPage: dataTableItemsPerPage[0],
                sortBy: [],
                sortDesc: [],
            },
        };
    },
    props: {
        route: {
            required: true,
        },
        reqData: {
            required: true,
        },
        // vedi note scritte alla fine di questo file
        mainTableComponent: {
            required: true,
        },
    },
    computed: {
        menuRoutes() {
            return this.$store.getters.availableMenu;
        },

        styleProps() {
            let found = false;
            let resultObj = { icon: null, title: null, color: null };

            let findIconColorAndTitle: Function = (node: any) => {
                if (!found) {
                    if (node.children && node.children.length > 0) {
                        node.children.forEach((child) => {
                            findIconColorAndTitle(child);
                        });
                    } else if (node.path == this.route) {
                        resultObj.icon = node.icon;
                        resultObj.title = this.$t(node.name_i18n);
                        resultObj.color = node.color;
                        found = true;
                    }
                }
            };

            this.menuRoutes.forEach((route) => {
                findIconColorAndTitle(route);
            });

            return resultObj;
        },

        icon() {
            return this.styleProps.icon ? this.styleProps.icon : "";
        },

        title() {
            return this.styleProps.title ? this.styleProps.title : "";
        },

        color() {
            return this.styleProps.color ? this.styleProps.color : "";
        },
    },
    watch: {
        deviceTreeSelectedObjectItems(newValue) {
            let newReqData = { ...this.reqData };

            newReqData.installationNames = null;
            newReqData.folderIds = null;
            if (newValue) {
                if (newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length > 0)
                    newReqData.installationNames = newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
                if (newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Folder).length > 0)
                    newReqData.folderIds = newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Folder).map((c) => c.id);
            }

            newReqData.offset = 0;
            newReqData.queryLimit = this.currentPaginationOptions.itemsPerPage;
            newReqData.orderBy = this.currentPaginationOptions.sortBy;
            newReqData.orderByDescending = this.currentPaginationOptions.sortDesc;

            this.$refs.mainTable.backToTheFirst();
            console.debug("Send request because device tree selection changed");
            this.$emit("send-request", newReqData);
        },
    },
    methods: {
        onReload() {
            console.debug("Send request to reload data");
            this.$emit("send-request", this.reqData);
        },

        onOptionsChanged(newOptions) {
            let needToSendRequest: boolean = false;

            if (this.currentPaginationOptions != null) {
                if (newOptions.page != this.currentPaginationOptions.page || newOptions.itemsPerPage != this.currentPaginationOptions.itemsPerPage) needToSendRequest = true;
                if (newOptions.sortBy.length != this.currentPaginationOptions.sortBy.length) needToSendRequest = true;
                else {
                    for (let index = 0; index < newOptions.sortDesc.length; index++) {
                        if (newOptions.sortDesc[index] != this.currentPaginationOptions.sortDesc[index]) {
                            needToSendRequest = true;
                            break;
                        }
                    }
                }
            } else {
                needToSendRequest = true;
            }

            this.currentPaginationOptions = newOptions;

            if (needToSendRequest) {
                let newReqData = { ...this.reqData };
                newReqData.offset = (this.currentPaginationOptions.page - 1) * this.currentPaginationOptions.itemsPerPage;
                newReqData.queryLimit = this.currentPaginationOptions.itemsPerPage;
                newReqData.orderBy = this.currentPaginationOptions.sortBy;
                newReqData.orderByDescending = this.currentPaginationOptions.sortDesc;

                console.debug("Send request because options changed");
                this.$emit("send-request", newReqData);
            }
        },

        onFiltersChanged(filters) {
            let newReqData = { ...this.reqData };
            newReqData.offset = 0;
            filters.forEach((filter) => {
                newReqData[filter.filterKey] = filter.currentSelections;
            });
            this.$refs.mainTable.backToTheFirst();
            console.debug("Send request because filters changed");
            this.$emit("send-request", newReqData);
        },

        backToTheFirst() {
            this.$refs.mainTable.backToTheFirst();
        },
    },
});

/** NOTE UTILI
Il componente mainTableComponent deve:
- avere la prop "installations" con la lista di tutte le installazioni da visualizzare
- deve utilizzare il componente TableFiltersRow
- la tabella v-data-table NON deve essere contenuta in uno skeleton o messa in v-if v-else con uno skeleton
 */
